import type { DocNode } from '@atlaskit/adf-schema/doc';

export type AdfSmartLink = {
	url: string;
	occurrenceIndex: number;
};

/**
 * Walks the ADF tree depth-first and returns one entry per unique smart link card node
 * (inlineCard, blockCard, embedCard), in document order. Duplicate URLs are ignored.
 *
 * occurrenceIndex is 0-based and increments across the whole document, so
 * duplicate URLs get distinct values
 */
export function extractSmartLinksFromAdf(doc: DocNode | null | undefined): AdfSmartLink[] {
	if (!doc) {
		return [];
	}

	const seen = new Set<string>();
	const results: AdfSmartLink[] = [];
	let counter = 0;

	function walk(node: { type: string; content?: any[]; attrs?: any }): void {
		const isCardNode =
			node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard';
		const url = typeof node.attrs?.url === 'string' ? node.attrs.url : '';
		if (isCardNode && url && !seen.has(url)) {
			seen.add(url);
			results.push({ url, occurrenceIndex: counter++ });
		}

		if (Array.isArray(node.content)) {
			node.content.forEach(walk);
		}
	}

	walk(doc);
	return results;
}
